// extracted by mini-css-extract-plugin
export default {"Description":"TillComparison-module--Description--Sz0bF","TillComparison":"TillComparison-module--TillComparison--2GFPV"};